import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

// utils
import axios, { fetcher } from '@utils/axios';

const initialState = {
  modal: false
};

const endpoints = {
  key: 'api/laboratories',
  list: '/', // server URL
  modal: '/modal', // server URL
  insert: '/insert', // server URL
  update: '/update', // server URL
  delete: '/delete' // server URL
};

export function useGetLabs() {
  const { data, isLoading, error, isValidating } = useSWR(endpoints.key + endpoints.list, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      customers: data?.result,
      customersLoading: isLoading,
      customersError: error,
      customersValidating: isValidating,
      customersEmpty: !isLoading && !data?.result?.length
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export async function insertLab(newCustomer) {
  try {
    const { status, data } = await axios.post(endpoints.key + endpoints.list, newCustomer);
    if (status && status >= 400 && status <= 599) {
      return;
    }
    mutate(
      endpoints.key + endpoints.list,
      (currentCustomer) => {
        const addedCustomer = [...currentCustomer.result, data.result];

        return {
          ...currentCustomer.result,
          result: addedCustomer
        };
      },
      false
    );
  } catch (error) {
    return error;
  }
}

export async function updateLab(customerId, updatedCustomer) {
  // to update local state based on key
  mutate(
    endpoints.key + endpoints.list,
    (currentCustomer) => {
      const newCustomer = currentCustomer.result.map((customer) =>
        customer.id === customerId ? { ...customer, ...updatedCustomer } : customer
      );

      return {
        ...currentCustomer,
        result: newCustomer
      };
    },
    false
  );

  // to hit server
  // you may need to refetch latest data after server hit and based on your logic
  // const data = { list: updatedCustomer };
  // await axios.post(endpoints.key + endpoints.update, data);
}

export async function deleteLab(customerId) {
  // to update local state based on key
  mutate(
    endpoints.key + endpoints.list,
    (currentCustomer) => {
      const nonDeletedCustomer = currentCustomer.result.filter((customer) => customer.id !== customerId);

      return {
        ...currentCustomer,
        result: nonDeletedCustomer
      };
    },
    false
  );

  // to hit server
  // you may need to refetch latest data after server hit and based on your logic
  // const data = { customerId };
  // await axios.post(endpoints.key + endpoints.delete, data);
}

export function useGetLabMaster() {
  const { data, isLoading } = useSWR(endpoints.key + endpoints.modal, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      customerMaster: data,
      customerMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerLabDialog(modal) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.modal,
    (currentCustomermaster) => {
      return { ...currentCustomermaster, modal };
    },
    false
  );
}
